import { useQuery } from 'react-query'

import { SystemPreferenceKeys } from '@webapp/platform/iam/entities/enums/SystemPreferenceKeys'
import { systemPreferenceQueryConfig } from '@webapp/platform/iam/query-configs/systemPreference'

export const useQueryOrganizationName = (): {
  organizationName: Nullable<string>
  isLoading: boolean
  isError: boolean
} => {
  const { data, isLoading, isError } = useQuery(
    systemPreferenceQueryConfig.getValue(SystemPreferenceKeys.ORGANIZATION_NAME)
  )

  return { organizationName: data?.value ?? null, isLoading, isError }
}
